module.exports = __webpack_public_path__ + "static/nhs-poster-acbf85185a96518ba3fe125e883981cd.jpg";